import React from 'react';
import styles from './GuestGapDevice.module.css';

export interface GuestGapDeviceProps {
  className?: string;
  leftLabel?: string;
  rightLabel?: string;
}

export const GuestGapDevice: React.FC<GuestGapDeviceProps> = ({
  className,
  leftLabel = 'Where you are now',
  rightLabel = 'Where you want to be',
}) => {
  const rootClass = className ? `${styles.device} ${className}` : styles.device;

  return (
    <div className={rootClass} aria-hidden="true">
      <div className={styles.rail}>
        <span className={styles.dotStart} />
        <span className={styles.line} />
        <span className={styles.dotEnd} />
      </div>
      <div className={styles.labels}>
        <p className={styles.labelLeft}>{leftLabel}</p>
        <p className={styles.labelRight}>{rightLabel}</p>
      </div>
    </div>
  );
};
